interface PriceFormatterOptions {
  currencySymbol?: string;
  decimalSeparator?: string;
  thousandsSeparator?: string;
}

export function formatPrice(
  price: number,
  options: PriceFormatterOptions = {},
): string {
  const {
    currencySymbol = '$',
    decimalSeparator = '.',
    thousandsSeparator = ',',
  } = options;

  if (isNaN(price)) {
    return 'Invalid Price';
  }

  // Convert price to a fixed string and check if decimal part is greater than 0
  const priceFixed = price.toFixed(2);
  const hasDecimal = price % 1 !== 0;

  // Split integer and decimal parts
  const [integerPart, decimalPart] = priceFixed.split('.');

  // Add thousands separator to the integer part
  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandsSeparator,
  );

  // Construct the final formatted price
  let finalFormattedPrice = `${currencySymbol}${formattedInteger}`;

  // Append decimal part if it's greater than 0
  if (hasDecimal) {
    finalFormattedPrice += `${decimalSeparator}${decimalPart}`;
  }

  return finalFormattedPrice;
}
